module.exports = __webpack_public_path__ + "img/mazda3-19.450ce745.png";